var exports = {
  "q7": "Item__jZ1pZ3",
  "ss": "current__itRjMz",
  "N_": "Link__YUC6c2",
  "Jc": "LeadingVisual__PgNfbt",
  "BG": "TrailingVisual__Um5HNN",
  "Qg": "visuallyHidden__rUVVq-",
};

module.exports = exports;
